import { Text, View } from '@react-pdf/renderer';
import { TableHeaderStyle } from '../../../styles';

const styles = TableHeaderStyle;

const InvoiceTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.ledger}>Vou #</Text>
    <Text style={styles.date}>Date</Text>
    <Text style={styles.type}>Type</Text>
    <Text style={styles.particulars}>Partculars</Text>
    <Text style={styles.ledgercheck}>Cheque/Bill #</Text>
    <Text style={styles.credit}>Debit (Rs)</Text>
    <Text style={styles.credit}>Credit (Rs)</Text>
    <Text style={styles.bal}>Balance</Text>
  </View>
);

export const VoucherTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.voucher}>Code</Text>
    <Text style={styles.particulars}>Name of Account</Text>
    <Text style={styles.particulars}>Description</Text>
    <Text style={styles.credit}>Cheque#</Text>
    <Text style={styles.credit}>Debit (Rs)</Text>
    <Text style={styles.credit}>Credit (Rs)</Text>
  </View>
);
export const TrialTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.trial}>Account Code</Text>
    <Text style={styles.trialparticulars}>Description</Text>
    <Text style={styles.trialcredit}>Debit (Rs)</Text>
    <Text style={styles.trialcredit}>Credit (Rs)</Text>
  </View>
);

export const CashBookTableHeader = headerData => {
  return (
    <>
      <View
        style={{ textAlign: 'center', flexDirection: 'row', marginTop: '40px' }}
      >
        <Text>CASH FLOW SUMMARY</Text>
      </View>
      <View style={styles.container}>
        <Text style={[styles.trialcreditCash, { textAlign: 'center' }]}> </Text>
        <Text style={[styles.trialcreditCash, { textAlign: 'center' }]}>
          Cash
        </Text>
        <Text style={[styles.trialcreditCash, { textAlign: 'center' }]}>
          Bank
        </Text>
        <Text
          style={[
            styles.trialcreditCash,
            { borderRightWidth: 0, textAlign: 'center' },
          ]}
        >
          Total
        </Text>
      </View>
      <View style={[styles.containerCash, { borderTopWidth: 0 }]}>
        <Text style={styles.trialcreditCash}>Opening Balance </Text>
        <Text style={styles.cashBookData}>
          {headerData.headerData.cashOpenningBalance.toLocaleString()}
        </Text>
        <Text style={styles.cashBookData}>
          {headerData.headerData.bankOpenningBalance.toLocaleString()}
        </Text>
        <Text style={[styles.cashBookData, { borderRightWidth: 0 }]}>
          {(
            headerData.headerData.cashOpenningBalance +
            headerData.headerData.bankOpenningBalance
          ).toLocaleString()}
        </Text>
      </View>
      <View style={[styles.containerCash, { borderTopWidth: 0 }]}>
        <Text style={styles.trialcreditCash}>Cash Received </Text>
        <Text style={styles.cashBookData}>
          {headerData.headerData.cashReceived.toLocaleString()}
        </Text>
        <Text style={styles.cashBookData}>
          {headerData.headerData.bankReceived.toLocaleString()}
        </Text>
        <Text style={[styles.cashBookData, { borderRightWidth: 0 }]}>
          {(
            headerData.headerData.cashReceived +
            headerData.headerData.bankReceived
          ).toLocaleString()}
        </Text>
      </View>
      <View style={[styles.containerCash, { borderTopWidth: 0 }]}>
        <Text style={styles.trialcreditCash}>In Hand </Text>
        <Text style={styles.cashBookData}>
          {' '}
          {(
            headerData.headerData.cashOpenningBalance +
            headerData.headerData.cashReceived
          ).toLocaleString()}
        </Text>
        <Text style={styles.cashBookData}>
          {(
            headerData.headerData.bankOpenningBalance +
            headerData.headerData.bankReceived
          ).toLocaleString()}
        </Text>
        <Text style={[styles.cashBookData, { borderRightWidth: 0 }]}>
          {(headerData.headerData.cashOpenningBalance +
            headerData.headerData.cashReceived +
            headerData.headerData.bankOpenningBalance +
            headerData.headerData.bankReceived).toLocaleString()}
        </Text>
      </View>
      <View style={[styles.containerCash, { borderTopWidth: 0 }]}>
        <Text style={styles.trialcreditCash}>Total Paid </Text>
        <Text style={styles.cashBookData}>
          {headerData.headerData.cashPaid.toLocaleString()}
        </Text>
        <Text style={styles.cashBookData}>
          {headerData.headerData.bankPaid.toLocaleString()}
        </Text>
        <Text style={[styles.cashBookData, { borderRightWidth: 0 }]}>
          {(
            headerData.headerData.cashPaid + headerData.headerData.bankPaid
          ).toLocaleString()}
        </Text>
      </View>
      <View style={[styles.containerCash, { borderTopWidth: 0 }]}>
        <Text style={styles.trialcreditCash}>Closing Balance</Text>
        <Text style={styles.cashBookData}>
          {' '}
          {(
            headerData.headerData.cashOpenningBalance +
            headerData.headerData.cashReceived -
            headerData.headerData.cashPaid
          ).toLocaleString()}
        </Text>
        <Text style={styles.cashBookData}>
          {(
            headerData.headerData.bankOpenningBalance +
            headerData.headerData.bankReceived -
            headerData.headerData.bankPaid
          ).toLocaleString()}
        </Text>
        <Text style={[styles.cashBookData, { borderRightWidth: 0 }]}>
          {(
            headerData.headerData.cashOpenningBalance +
            headerData.headerData.cashReceived +
            headerData.headerData.bankOpenningBalance +
            headerData.headerData.bankReceived -
            headerData.headerData.cashPaid -
            headerData.headerData.bankPaid
          ).toLocaleString()}
        </Text>
      </View>
      <View
        style={[
          styles.containerCash,
          {
            marginTop: 12,
            backgroundColor: '#EDF5E1',
            fontFamily: 'Helvetica-Bold',
          },
        ]}
      >
        <Text style={styles.trialcreditCash}>Daily Cash Balance</Text>
        <Text style={styles.cashBookData}>
          {' '}
          {(
            headerData.headerData.cashReceived -
            headerData.headerData.cashPaid +
            headerData.headerData.bankReceived -
            headerData.headerData.bankPaid
          ).toLocaleString()}
        </Text>
        {/* <Text style={styles.cashBookData}></Text> */}
        {/* <Text style={[styles.cashBookData, { borderRightWidth: 0 }]}></Text> */}
      </View>
    </>
  );
};

export default InvoiceTableHeader;
